import { RegExp } from "core-js";

export const FileType = Object.freeze({
    jpeg: {
        type: "jpeg",
        extensions: [".jpg", ".jpeg", ".jfif", ".pjpeg", ".pjp"],
        mime: "image/jpeg",
        displayable: true
    },
    png: {
        type: "png",
        extensions: [".png"],
        mime: "image/png",
        displayable: true
    },
    pdf: {
        type: "pdf",
        extensions: [".pdf"],
        mime: "application/pdf",
        displayable: false

    },
    csv: {
        type: "csv",
        extensions: [".csv"],
        mime: "text/csv",
        displayable: false
    }
});

export function checkFileType(fileName, acceptedFileTypes) {
    // Find index of last "." if available and take slice
    if (acceptedFileTypes) {
        const givenFileType = "." + fileName.slice((fileName.lastIndexOf(".") - 1) + 2);
        const concatExtensions = acceptedFileTypes.extensions; //[].concat.apply([], Object.values(acceptedFileTypes).map(type => type.extensions));

        return concatExtensions.includes(givenFileType);
    }
}